import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { GetSubscriptionPlans } from '../apiconstants/constants';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import axios from 'axios';
import SubscriptionStatus from '../commonlayouts/subscriptionstatus';

const PricingSection = () => {
  const navigate = useNavigate();
  const [plansByType, setPlansByType] = useState({});
  const [billingType, setBillingType] = useState({});
   const isSubscriptionActive = localStorage.getItem("isSubscriptionActive");
const subscriptionEndDate = localStorage.getItem("subscriptionEndDate")
const planName = localStorage.getItem("planName")
  useEffect(() => {
    const showAlert = localStorage.getItem("showPostPaymentAlert");
    if (showAlert === "true") {
      Swal.fire({
        title: "Action Required",
        text: "Please logout and login again to get full SideNavbar functionalities.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#2e3192"
      });
      localStorage.removeItem("showPostPaymentAlert");
    }
  }, []);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get(GetSubscriptionPlans.APIURL);
        const filteredPlans = response.data.filter(plan => plan.planName !== "Trail Plan");

        const groupedPlans = {};

        filteredPlans.forEach(plan => {
          const baseName = plan.planName.replace("Annual ", "").replace(" Plan", "");
          if (!groupedPlans[baseName]) groupedPlans[baseName] = {};

          if (plan.planName.startsWith("Annual")) {
            groupedPlans[baseName].Annually = plan;
          } else {
            groupedPlans[baseName].Monthly = plan;
          }
        });

        const defaultBilling = {};
        Object.keys(groupedPlans).forEach(name => {
          defaultBilling[name] = "Monthly";
        });

        setPlansByType(groupedPlans);
        setBillingType(defaultBilling);
      } catch (error) {
        console.error("Error fetching subscription plans:", error);
      }
    };

    fetchPlans();
  }, []);

  const handleSelect = (planObj, type, billing) => {
    const selectedPlan = planObj[billing];
    if (!selectedPlan) return;

    const amount = selectedPlan.price;
    navigate("/Employer/Payment", {
      state: {
        amount,
        type,
        plan: billing,
        planId: selectedPlan.planID
      }
    });
  };

  return (
    <ConsultantLayout>
      <SubscriptionStatus/>      
           {isSubscriptionActive == 'false' ? <p style={{minHeight:400}}> </p> 
             :
      <div style={{ border: "none", backgroundColor: "#fff" }}>
        <div className="card-header d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center"
          style={{ border: "none", backgroundColor: "#fff" }}>
          <h5 className="welcome-text" style={{ fontSize: "20px", color: "#00a7ac", margin: 0 }}>
            Subscription Plans
          </h5>
          <div className="d-flex justify-content-between align-items-center flex-wrap ">
            {planName !== 'null' && planName !== null &&
 subscriptionEndDate !== 'null' && subscriptionEndDate !== null && (
  <p
    className="welcome-text"
    style={{ fontSize: "16px", color: "#000", margin: 0, fontWeight: 600 }}
  >
    {planName} – Ending on {subscriptionEndDate.split('T')[0]}
  </p> 
)}
 <button className='btn btn-primary ml-3' onClick={() => navigate("/Employer/SubscriptionHistory")}>
    Subscription History
  </button>
        </div>
</div>
        <hr />
        <div className="container">
          <div className="row mt-2">
            {Object.entries(plansByType).map(([planType, planOptions]) => {
              const currentBilling = billingType[planType] || "Monthly";
              const planData = planOptions[currentBilling];
              const planId = planData?.planID;

              return (
                <div className="col-sm-12 col-lg-4 col-xl-4 col-md-4" key={planId}>
                  <div className="card shadow-lg text-center p-3 mt-3" style={{ border: 'none', height: "450px" }}>
                    <h4 className="mb-3">{planType} Plan</h4>
                    <div className="mb-2" style={{ height: "120px" }}>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>
                        ${planData.price}
                      </p>
                      <p>{currentBilling === "Monthly" ? 'billed Monthly' : 'billed Annually (2 Months Free)'}</p>
                      <p className="text-gray-600">{planData.interviewLimit} Interviews</p>
                    </div>
                    <div className="text-center mt-5 mb-3">
                      <button
                        className='btn btn-primary'
                        style={{ borderRadius: "20px" }}
                        onClick={() => handleSelect(planOptions, planType.toLowerCase(), currentBilling)}
                      >
                        Pay
                      </button>
                    </div>
                    <div className="toggle-container text-center mx-auto">
                      <div
                        className={`toggle-button ${currentBilling === "Monthly" ? "Monthly" : ""}`}
                        onClick={() => setBillingType(prev => ({ ...prev, [planType]: "Monthly" }))}
                      >
                        Monthly
                      </div>
                      <div
                        className={`toggle-button ${currentBilling === "Annually" ? "Annually" : ""}`}
                        onClick={() => setBillingType(prev => ({ ...prev, [planType]: "Annually" }))}
                      >
                        Annually
                      </div>
                    </div>
                    <p className='mt-3' style={{ fontWeight: 'bold' }}>
                      {currentBilling === "Monthly"
                        ? "(Switch to annual plan to get 2 months free)"
                        : "(2 Months Free)"}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <p style={{ marginLeft: '50px', marginTop: "20px" }}>
            Note: Higher-tier users will have added flexibility, such as carry-forward interviews and dedicated support.
          </p>
        </div>

        {/* Embedded Style */}
        <style>
          {`
            .toggle-container {
              display: flex;
              width: 150px;
              height: 40px;
              border-radius: 20px;
              background: #ccc;
              overflow: hidden;
              border: 1px solid #00a7ac;
              margin: 0 auto;
            }

            .toggle-button {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 50%;
              height: 100%;
              cursor: pointer;
              transition: all 0.3s ease;
              color: #00a7ac;
              font-weight: bold;
              background-color: #fff;
              font-size: 12px;
            }

            .Annually,
            .Monthly {
              background-color: #00a7ac !important;
              color: #fff !important;
            }
          `}
        </style>
      </div>
}
    </ConsultantLayout>
  );
};

export default PricingSection;
